export default {
  submitText: '续约',
  emptyBtn: false,
  column: [
    {
      label: '车场名称',
      prop: 'spaceId',
      span: 8,
      search: true,
      editDisabled: true,
      cell: true,
      type: 'tree',
      props: {
        label: 'title',
        value: 'key',
      },
      rules: [
        {
          required: true,
        },
      ],
      dicUrl: '/api/v4ward/carv2/ParkSpace/tree',
    },
    {
      label: '所属小区',
      type: 'tree',
      display: false,
      span: 8,
      dicUrl: '/api/base/property/tree1?objectTypeKey=1',
      props: {
        label: 'title',
        value: 'id',
      },
      prop: 'areaId',
    },
    {
      label: '车牌号',
      prop: 'carNo',
      span: 8,
      search: true,
      type: 'tree',
      dicData: [],
      props: {
        label: 'carNo',
        value: 'carNo',
      },
      rules: [
        {
          required: true,
          message: '请输入车牌号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '车辆类型',
      editDisabled: true,
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      prop: 'carType',
      search: true,
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入车辆类型',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '租赁起期',
      prop: 'buyStartTime',
      span: 8,
      type: 'date',
      format: 'yyyy-MM-dd 00:00:00',
      valueFormat: 'yyyy-MM-dd 00:00:00',
      editDisabled: true,
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },
      ],
    },
    {
      label: '套餐说明',
      prop: 'remark',
      hide: true,
      disabled: true,
      span: 16,
      rules: [
        {
          required: false,
          message: '请输入备注1',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收费套餐',
      prop: 'ruleId',
      type: 'tree',
      editDisabled: true,
      dicData: [],
      props: {
        label: 'setmealName',
        value: 'id',
      },
      span: 8,
      rules: [
        {
          required: true,
          message: '请输入收费规则id',
          trigger: 'change',
        },
      ],
    },

    {
      label: '租赁止期',
      prop: 'buyEndTime',
      type: 'date',
      format: 'yyyy-MM-dd 23:59:59',
      valueFormat: 'yyyy-MM-dd hh:mm:ss',
      span: 8,
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },
      ],
    },
    {
      label: '应收金额',
      prop: 'shouldMoney',
      precision: 2,
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      minRows: 0.01,
      span: 8,
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入应收金额',
          trigger: 'change',
        },
      ],
    },
    {
      label: '优惠金额',
      hide: true,
      disabled: true,
      prop: 'cutMoney',
      span: 8,
      precision: 2,
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      minRows: 0,
    },
    {
      label: '支付金额',
      prop: 'payMoney',
      span: 8,
      disabled: true,
      precision: 2,
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      minRows: 0.01,
      rules: [
        {
          required: true,
          message: '请输入应收金额',
          trigger: 'change',
        },
      ],
    },
    {
      label: '客户姓名',
      span: 8,
      search: true,
      prop: 'customerName',
      rules: [
        {
          required: true,
          message: '请输入客户姓名',
          trigger: 'change',
        },
      ],
    },
    {
      label: '客户手机',
      prop: 'customerPhone',
      span: 8,
      search: true,
      rules: [
        {
          required: true,
          message: '请输入客户手机号',
          trigger: 'change',
        },
      ],
    },

    {
      label: '状态',
      prop: 'status',
      display: false,
    },
    {
      label: '操作',
      prop: 'operateType',
      display: false,
    },
    {
      label: '缴费时间',
      prop: 'payTime',
      hide: true,
      display: false,
      span: 8,
      rules: [
        {
          required: true,
          message: '请输入缴费时间',
          trigger: 'change',
        },
      ],
    },
    {
      label: '支付方式',
      hide: true,
      prop: 'payType',
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      rules: [
        {
          required: false,
          message: '请输入支付方式',
          trigger: 'change',
        },
      ],
    },
    {
      label: '条形码',
      hide: true,
      prop: 'payCode',
      span: 8,
      rules: [
        {
          message: '请输入支付方式',
          trigger: 'change',
        },
      ],
    },
    {
      label: '车位编号',
      prop: 'lotNo',
      hide: true,
      span: 8,
      rules: [
        {
          required: false,
          message: '请输入停车车位编号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '房间名称',
      prop: 'areaName',
      hide: true,
      span: 8,
      rules: [
        {
          required: false,
          message: '请输入房间名称',
          trigger: 'change',
        },
      ],
    },
    // {
    //   label: '电子资料',
    //   prop: 'imgUrl',
    //   dataType: 'array',
    //   type: 'upload',
    //   hide:true,
    //   propsHttp: {
    //     res: 'data.0',
    //   },
    //   span: 24,
    //   listType: 'picture-card',
    //   tip: '只能上传jpg/png文件，且不超过500kb',
    //   action: '/imgupload',
    // },

    {
      label: '备注',
      prop: 'remark1',
      hide: true,
      span: 24,
      rules: [
        {
          required: false,
          message: '请输入备注1',
          trigger: 'change',
        },
      ],
    },
  ],
};
